import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { errorCallback, makeUrl } from '../../const/const';
import { GET_CURRENT_USER, MAKE_USER_REQUEST, postFetchRequest, getFetchRequest } from '../../store/requests';

// Локальные ключи для fallback-хранения
const LS_KEY = 'elsi_notifications_settings';

const TabNotifications = ({ userId: externalUserId }) => {
    const [userId, setUserId] = useState(externalUserId || '');
    const [email, setEmail] = useState('');
    const [subscribeOrders, setSubscribeOrders] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState({ type: '', message: '' });
    const ignoreIncomingRef = useRef(false);

    // Загружаем только userId текущего пользователя (без подстановки email из профиля)
    useEffect(() => {
        if (!userId) {
            getFetchRequest(makeUrl([GET_CURRENT_USER]), (res) => {
                if (res && res.id) setUserId(res.id);
            }, errorCallback);
        }
    }, [userId]);

    // Пробуем загрузить настройки с API; если не доступно — из localStorage
    useEffect(() => {
        if (!userId) return;
        const url = makeUrl([MAKE_USER_REQUEST, userId, '/notifications/']);
        getFetchRequest(url, (res) => {
            if (ignoreIncomingRef.current) return;
            if (res && res.ok === undefined) {
                // Предполагаем, что пришёл JSON объект настроек
                if (res.emailForNotifications) setEmail(res.emailForNotifications);
                if (typeof res.notifyOrders === 'boolean') setSubscribeOrders(res.notifyOrders);
                // Никаких подстановок из профиля/LS — только БД уведомлений
            }
        }, () => {});
    }, [userId]);

    const handleSave = () => {
        if (subscribeOrders && !email) {
            setError({ type: 'validate', message: 'Укажите электронную почту или отключите уведомления' });
            return;
        }
        setError({ type: '', message: '' });
        setSaving(true);
        ignoreIncomingRef.current = true;
        const body = { emailForNotifications: email, notifyOrders: subscribeOrders };
        const url = makeUrl([MAKE_USER_REQUEST, userId, '/notifications/']);
        postFetchRequest(url, body, (res) => {
            setSaving(false);
            if (res && (res.ok || res.id || res.emailForNotifications)) {
                try { localStorage.setItem(LS_KEY, JSON.stringify(body)); } catch (e) { console.warn('Failed to cache notifications settings', e); }
                setError({ type: 'success', message: 'Настройки уведомлений сохранены' });
                setTimeout(() => setError({ type: '', message: '' }), 2500);
                // Явно синхронизируем состояние с тем, что отправили
                setEmail(body.emailForNotifications || '');
                setSubscribeOrders(!!body.notifyOrders);
            } else {
                setError({ type: 'save', message: 'Не удалось сохранить настройки' });
            }
            // Разрешаем принимать будущие ответы (если компонент не размонтирован)
            setTimeout(() => { if (ignoreIncomingRef.current) ignoreIncomingRef.current = false; }, 0);
        }, (e) => {
            setSaving(false);
            errorCallback(e);
            // Сохраняем локально как fallback
            try { localStorage.setItem(LS_KEY, JSON.stringify(body)); } catch (err) { console.warn('Failed to cache notifications settings (fallback)', err); }
            setError({ type: 'success', message: 'Настройки сохранены локально' });
            setTimeout(() => setError({ type: '', message: '' }), 2500);
            setEmail(body.emailForNotifications || '');
            setSubscribeOrders(!!body.notifyOrders);
            setTimeout(() => { if (ignoreIncomingRef.current) ignoreIncomingRef.current = false; }, 0);
        }, true);
    };

    return (
        <>
            <div className="setup-customer__section notifications-section">
                <h3 className="setup-customer__title">Уведомления</h3>
                <form className="profile-form setup-customer__form">
                    <label name="notify-email" className="profile-form__item">Электронная почта для уведомлений
                        <input
                            className="profile-form__input"
                            placeholder="-"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </label>

                    <div className="profile-form__two-columns">
                        <label className="profile-form__item profile-form__agreement-label" htmlFor="notify-orders">
                            <input
                                id="notify-orders"
                                type="checkbox"
                                className="visually-hidden"
                                checked={subscribeOrders}
                                onChange={(e) => setSubscribeOrders(e.target.checked)}
                                role="switch"
                                aria-checked={subscribeOrders}
                            />
                            <span className="consent-toggle" aria-hidden="true"></span>
                            <span>Уведомлять <br className='mobile-br' /> о состоянии запросов и заказов</span>
                        </label>
                    </div>

                    <div className="profile-form__submit-section setup-org">
                        <button
                            onClick={handleSave}
                            className={`order-detail-btn order-detail-btn-submit setup-customer__button ${(!email || saving) ? 'button_disabled' : ''}`}
                            type="button"
                            disabled={!email || saving}
                        >
                            {saving ? 'Сохранение...' : 'Сохранить'}
                        </button>
                    </div>
                    {error.type && error.message ? (
                        <p className={`alert ${error.type==='success' ? 'alert-success' : ''}`}>{error.message}</p>
                    ) : null}
                </form>
            </div>
        </>
    );
};

TabNotifications.propTypes = {
    userId: PropTypes.string,
};

export default TabNotifications;


